import component from './ProOptionWrapper.vue'
export default component
